import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import menuItems from 'config/MenuItems'
import routes from 'config/routes'
import usePathname from 'hooks/usePathname'
import {
  isRouteAllowed,
  LIMITED_MODE_DEFAULT_ROUTE,
  LIMITED_MODE_ENABLED
} from 'config/limitedMode'
import SignOutPage from 'pages/Auth/SignOutPage'

const visibleMenuItems = LIMITED_MODE_ENABLED
  ? menuItems.filter(({ routeName }) => isRouteAllowed(routeName))
  : menuItems

const visibleRoutes = LIMITED_MODE_ENABLED
  ? routes.filter(({ routeName }) => isRouteAllowed(routeName))
  : routes

const allRoutes = [...visibleMenuItems, ...visibleRoutes]

const MainRouter = () => {
  const history = useHistory()
  const pathname = usePathname()

  const matchedRoute = allRoutes.find(({ routeName }) => routeName === pathname)

  useEffect(() => {
    if (matchedRoute || pathname === '/sign-out') {
      return
    }

    if (LIMITED_MODE_ENABLED) {
      history.replace(LIMITED_MODE_DEFAULT_ROUTE)
    }
  }, [history, matchedRoute, pathname])

  if (pathname === '/sign-out') {
    return <SignOutPage key="/sign-out" />
  }

  if (matchedRoute) {
    const PageComponent = matchedRoute.component
    return <PageComponent key={pathname} />
  }

  return null
}

export default MainRouter
